// Web service urls
export const LONG_RUN_WEB_SERVICE_BASE_URL = 'truckrouting/service/';
export const LONG_RUN_FORECAST_WEB_SERVICE = `${LONG_RUN_WEB_SERVICE_BASE_URL}v1/computeForecastConsumption`;
export const LONG_RUN_GET_VERSION_WEB_SERVICE = `${LONG_RUN_WEB_SERVICE_BASE_URL}getVersion`;

export const LONG_RUN_GET_TRUCKS_URL = 'api/getTrucks/';
